<template>
  <div>
    <div id="map-container-1">
      <div id="regions-div"></div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";

export default {
  name: "CountryChart",
  props: ["provider"],
  watch: {
    provider: function(provider) {
      this.generateCountryGraph(this.provider);
    }
  },
  mounted() {
    this.generateCountryGraph(this.provider);
  },
  methods: {
    generateCountryGraph: function(provider) {
      // Heatmap
      google.charts.load("current", { packages: ["geochart"] });
      google.charts.setOnLoadCallback(drawRegionsMap);

      function drawRegionsMap() {
        var data = new google.visualization.DataTable();

        data.addColumn("string", "Country");
        data.addColumn("number", "Value");
        data.addColumn({ type: "string", role: "tooltip", p: { html: true } });

        provider.provider_countries.forEach(country => {
          if (country.country != null) {
            data.addRows([
              [
                {
                  v: country.country.code,
                  f: country.country.name
                },
                country.relevancy,
                "<div />"
              ]
            ]);
          }
        });

        data.addRows([
          [
            {
              v: "ZZ",
              f: ""
            },
            0,
            "<div />"
          ]
        ]);
        data.addRows([
          [
            {
              v: "ZZ",
              f: ""
            },
            1,
            "<div />"
          ]
        ]);
        var geochart = new google.visualization.GeoChart($("#regions-div")[0]);

        geochart.draw(data, {
          colorAxis: {
            colors: ["#1fc600", "#67a339", "#4f772c", "#006d2a", "#014419"]
          },
          backgroundColor: "#bdd0da",
          legend: "none",
          datalessRegionColor: "#f1ebdc",
          tooltip: { isHtml: true },
          enableRegionInteractivity: false
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/charts/CountryChart.vue